import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Menu, ListItemIcon, ListItemText, Box } from '@mui/material/';

import { useLocation, Link } from 'react-router';
import premiumIcon from '../../../public/images/account_menu/premium.webp';
import faqIcon from '../../../public/images/account_menu/faq.webp';
import subscriptionIcon from '../../../public/images/account_menu/subscription.webp';
import doorIcon from '../../../public/images/account_menu/door_icon.png';
import policeIcon from '../../../public/images/account_menu/policeman.svg';
import { StyledListItemButton } from '../../UI/Buttons/ListItemButton';

const PREFIX = 'AccountMenu';

const classes = {
	paper: `${PREFIX}-paper`,
	button: `${PREFIX}-button`
};

const StyledMenu = styled(Menu)(({ theme }) => ({
	[`&.${classes.paper}`]: {
		border: '1px solid #d3d4d5'
	}
}));

export default function AccountMenu({ anchorEl, handleClose, handleLogout }) {
	const location = useLocation();

	useEffect(() => {
		if (anchorEl) {
			handleClose();
		}
	}, [location]);

	return (
		<StyledMenu
			className={classes.paper}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
			onClose={handleClose}
		>
			<StyledListItemButton component={Link} to="/profil">
				<ListItemIcon>
					<Box
						component="img"
						alt="policeIcon"
						src={policeIcon}
						sx={{ height: '30px', width: '30px' }}
					/>
				</ListItemIcon>
				<ListItemText primary="Profilul meu" />
			</StyledListItemButton>
			<StyledListItemButton component={Link} to="/profil/intrebari-frecvente">
				<ListItemIcon>
					<Box
						component="img"
						alt="policeIcon"
						src={faqIcon}
						sx={{ height: '30px', width: '30px' }}
					/>
				</ListItemIcon>
				<ListItemText primary="Intrebari frecvente" />
			</StyledListItemButton>
			<StyledListItemButton component={Link} to="/profil/premium">
				<ListItemIcon>
					<Box
						component="img"
						alt="policeIcon"
						src={premiumIcon}
						sx={{ height: '30px', width: '30px' }}
					/>
				</ListItemIcon>
				<ListItemText primary="Beneficii cont" />
			</StyledListItemButton>
			<StyledListItemButton component={Link} to="/profil/premium/abonament">
				<ListItemIcon>
					<Box
						component="img"
						alt="subscriptionIcon"
						src={subscriptionIcon}
						sx={{ height: '30px', width: '30px' }}
					/>
				</ListItemIcon>
				<ListItemText primary="Abonamente" />
			</StyledListItemButton>
			<StyledListItemButton onClick={handleLogout}>
				<ListItemIcon>
					<Box component="img" alt="door" src={doorIcon} sx={{ height: '30px', width: '30px' }} />
				</ListItemIcon>
				<ListItemText primary="Ieșire cont" />
			</StyledListItemButton>
		</StyledMenu>
	);
}
